import { Component, Input } from "@angular/core";
import { Account } from "@common/ADAPT.Common.Model/account/account";
import { UserType } from "@common/ADAPT.Common.Model/embed/user-type";
import { Organisation } from "@common/ADAPT.Common.Model/organisation/organisation";
import { ConfigureFeatureBase } from "@org-common/lib/configuration/base-components/configure-feature-base";
import { IConfigItem } from "@org-common/lib/configuration/configuration.interfaces";
import { ConfigurationService } from "@org-common/lib/configuration/configuration.service";
import { AccountService } from "@org-common/lib/organisation/account/account.service";
import { OrganisationService } from "@org-common/lib/organisation/organisation.service";
import { firstValueFrom } from "rxjs";

@Component({
    selector: "adapt-configure-organisation-profile",
    templateUrl: "./configure-organisation-profile.component.html",
    standalone: false,
})
export class ConfigureOrganisationProfileComponent extends ConfigureFeatureBase {
    public static readonly DefaultOrgImageUrl = "/content/images/default_org.png";
    public readonly defaultImageSrcOrg = ConfigureOrganisationProfileComponent.DefaultOrgImageUrl;

    @Input() public configItem?: IConfigItem;

    public organisation?: Organisation;
    public account?: Account;

    public UserType = UserType; // to use in the template

    constructor(
        configurationService: ConfigurationService,
        private orgService: OrganisationService,
        private accountService: AccountService
    ) {
        super(configurationService);
    }

    public async initialiseData() {
        this.organisation = await this.orgService.promiseToGetOrganisation();
        this.account = await firstValueFrom(this.accountService.getAccount());
    }

    public onCancel() {
        // you can cancel the org image change, we should notify that the org image id has been changed again
        this.orgService.notifyOrganisationImageIdChanged();
        return super.onCancel();
    }

    public onImageIdentifierChange(value: string) {
        if (this.organisation!.imageIdentifier !== value) {
            this.organisation!.imageIdentifier = value;
            this.orgService.notifyOrganisationImageIdChanged();
        }
    }
}
